import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Ravintolan rekisteröinti',
  description: 'Vaihe {{activeStep}}/{{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Perustiedot',
    [Step.BusinessDetails]: 'Yrityksen tiedot',
  },
  form: {
    name: {
      label: 'Ravintolan nimi',
      placeholder: 'Syötä ravintolan nimi',
    },
    timezone: {
      label: 'Aikavyöhyke',
      placeholder: 'Hae kaupunkia tai aikavyöhykettä',
      inference_failed: 'Emme pystyneet päättelemään aikavyöhykettä tästä osoitteesta – valitse se itse.',
    },
    google_place: {
      label: 'Valittu Google-paikka: {{name}}',
    },
    is_franchise: {
      label: 'Ravintola kuuluu brändiin',
    },
    sync_lieferando_brand: {
      label: 'Hae brändin tiedot (logo, pääväri) Lieferandosta',
    },
    import_menu: {
      label: 'Tuo valikko',
    },
    lieferando_url: {
      label: 'Lieferando-URL',
      placeholder: 'Ravintolan URL Lieferandossa',
    },
    other_platforms: {
      label: 'Nykyiset toimitusalustat',
      description: 'Valitse kaikki alustat, joissa olet tällä hetkellä listattuna',
    },
    pos_system: {
      label: 'Nykyinen kassajärjestelmä',
      placeholder: 'Valitse kassajärjestelmäsi',
      options: {
        [PosSystems.Other]: 'Muu',
      },
    },
    delivery_mode: {
      label: 'Toimitustapa',
      placeholder: 'Valitse toimitustapa',
      options: {
        [DeliveryMode.Internal]: 'Sisäinen (omat kuljettajat)',
        [DeliveryMode.External]: 'Ulkoinen (kolmas osapuoli)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Kuukausittainen toimitusmyynti',
      description: 'Kokonaismyynti kaikilla toimitusalustoilla',
      placeholder: 'Valitse myyntiväli',
      options: {
        other: 'Muu',
      },
      other: {
        placeholder: 'Syötä myyntimäärä',
      },
    },
    lead_source: {
      label: 'Liidin lähde',
      description: 'Mistä kuulit meistä?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Myynnin kehitysedustajan (SDR) yhteydenotto',
        },
        [LeadSources.Inbound]: {
          title: 'Saapuva',
          description: 'Tuli luoksemme verkkosivuston tai markkinoinnin kautta',
        },
        [LeadSources.Referral]: {
          title: 'Suositus – nykyinen ravintola',
          description: 'Suositeltu jonkin kumppaniravintolamme toimesta',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Itse hankittu – kylmä',
          description: 'Löydetty kylmän yhteydenoton tai hakemisen kautta',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Itse hankittu – suositus',
          description: 'Henkilökohtainen verkosto tai yhteys',
        },
        [LeadSources.Tipster]: {
          title: 'Vinkkaaja',
          description: 'Foodamigos maksaa henkilölle/yritykselle X palkkion suosituksesta',
        },
      },
    },
    sdr: {
      description: 'Valitse SDR, joka vastaa tämän liidin hankinnasta',
    },
    has_instagram_profile: {
      label: 'Instagram-profiili',
      description: 'Onko ravintolallasi Instagram-profiili?',
      options: {
        true: 'Kyllä',
        false: 'Ei',
      },
    },
  },
  buttons: {
    back: 'Takaisin',
    next: 'Seuraava',
    complete_registration: 'Viimeistele rekisteröinti',
  },
  basic_information: {
    title: 'Perustiedot',
    description: 'Syötä ravintolan perustiedot ja yhteystiedot',
  },
  additional_options: {
    title: 'Lisäasetukset',
    description: 'Määritä tämän ravintolan lisäasetukset',
  },
  restaurant_type: {
    title: 'Ravintolatyyppi ja palvelumalli',
    description: 'Valitse muoto, joka kuvaa parhaiten tämän ravintolan palvelutyyliä',
  },
  cuisine_type: {
    title: 'Ruokakategoriat ja keittiötyypit',
    description: 'Valitse kaikki tähän ravintolaan sopivat ruokakategoriat ja keittiötyypit',
    placeholder: 'Hae keittiötyyppejä',
  },
  business_details: {
    title: 'Yrityksen tiedot',
    description: 'Auta meitä ymmärtämään nykyistä toimintaasi',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Täyden palvelun ravintola',
      description: 'Pöytiintarjoilu ja istumapaikat',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast Casual',
      description: 'Tilaus tiskiltä/sovelluksesta, QSR:ää korkeampi laatu ja muokattavuus, istumapaikat valinnaisia',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Pikapalvelu (QSR) / Noutoruoka',
      description: 'Nopeuteen keskittyvä tiskipalvelu; pääasiassa noutoruokaa',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Kahvila ja leipomo',
      description: 'Kahvia, leivonnaisia, kevyitä aterioita, aamiainen/brunssi',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Jälkiruoat ja jäätelö',
      description: 'Makeisiin keskittyvät konseptit',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Juomat ja baari',
      description: 'Juomapainotteiset paikat; ruoka valinnaista; alkoholin toimitus paikallisten sääntöjen mukaan',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Vain toimitus / haamukeittiö',
      description: 'Ei myymälää; virtuaalibrändejä ja pilvikeittiöitä',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Hampurilaiset',
    [CuisineTypes.ChickenFried]: 'Paistettu kana',
    [CuisineTypes.Wings]: 'Siivet',
    [CuisineTypes.KebabDoner]: 'Kebab/Donerkebab',
    [CuisineTypes.Sandwiches]: 'Voileivät',
    [CuisineTypes.Wraps]: 'Wrapit',
    [CuisineTypes.Salads]: 'Salaatit',
    [CuisineTypes.Healthy]: 'Terveellinen',
    [CuisineTypes.Bowls]: 'Bowlit',
    [CuisineTypes.Vegan]: 'Vegaaninen',
    [CuisineTypes.Vegetarian]: 'Kasvisruoka',
    [CuisineTypes.GlutenFree]: 'Gluteeniton',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japanilainen',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Korealainen',
    [CuisineTypes.KoreanFriedChicken]: 'Korealainen paistettu kana',
    [CuisineTypes.Chinese]: 'Kiinalainen',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Kantonilainen/Dim Sum',
    [CuisineTypes.Thai]: 'Thaimaalainen',
    [CuisineTypes.Vietnamese]: 'Vietnamilainen',
    [CuisineTypes.Malaysian]: 'Malesialainen',
    [CuisineTypes.Indonesian]: 'Indonesialainen',
    [CuisineTypes.Filipino]: 'Filippiiniläinen',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplingit/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Intialainen',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistanilainen',
    [CuisineTypes.SriLankan]: 'Sri Lankalainen',
    [CuisineTypes.Nepalese]: 'Nepalilainen',

    [CuisineTypes.Turkish]: 'Turkkilainen',
    [CuisineTypes.Lebanese]: 'Libanonilainen',
    [CuisineTypes.Syrian]: 'Syyrialainen',
    [CuisineTypes.Israeli]: 'Israelilainen',
    [CuisineTypes.Egyptian]: 'Egyptiläinen',
    [CuisineTypes.PersianIranian]: 'Persialainen/Iranilainen',
    [CuisineTypes.Iraqi]: 'Irakilainen',
    [CuisineTypes.Afghan]: 'Afganistanilainen',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grilli',
    [CuisineTypes.Greek]: 'Kreikkalainen',
    [CuisineTypes.Mediterranean]: 'Välimerellinen',

    [CuisineTypes.Italian]: 'Italialainen',
    [CuisineTypes.Pasta]: 'Pasta',
    [CuisineTypes.French]: 'Ranskalainen',
    [CuisineTypes.SpanishTapas]: 'Espanjalainen/Tapas',
    [CuisineTypes.Portuguese]: 'Portugalilainen',
    [CuisineTypes.German]: 'Saksalainen',
    [CuisineTypes.Austrian]: 'Itävaltalainen',
    [CuisineTypes.Balkan]: 'Balkanilainen',
    [CuisineTypes.Hungarian]: 'Unkarilainen',
    [CuisineTypes.Polish]: 'Puolalainen',
    [CuisineTypes.Czech]: 'Tšekkiläinen',
    [CuisineTypes.Georgian]: 'Georgialainen',

    [CuisineTypes.Mexican]: 'Meksikolainen',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Perulainen',
    [CuisineTypes.Brazilian]: 'Brasilialainen',
    [CuisineTypes.Argentinian]: 'Argentiinalainen',
    [CuisineTypes.Caribbean]: 'Karibialainen',
    [CuisineTypes.BBQAmerican]: 'BBQ/Amerikkalainen',
    [CuisineTypes.Steakhouse]: 'Pihvitalo',
    [CuisineTypes.AmericanGeneral]: 'Amerikkalainen (yleinen)',
    [CuisineTypes.HotDogs]: 'Hodarit',

    [CuisineTypes.Seafood]: 'Merenelävät',
    [CuisineTypes.FishAndChips]: 'Kala ja ranskalaiset',
    [CuisineTypes.SteamedFish]: 'Höyrytetty kala',

    [CuisineTypes.BreakfastBrunch]: 'Aamiainen/Brunssi',
    [CuisineTypes.Bagels]: 'Bagelit',
    [CuisineTypes.Bakery]: 'Leipomo',
    [CuisineTypes.PastryDessert]: 'Leivonnaiset/Jälkiruoat',
    [CuisineTypes.WafflesCrepes]: 'Vohvelit/Crepet',
    [CuisineTypes.IceCreamGelato]: 'Jäätelö/Gelato',
    [CuisineTypes.Donuts]: 'Donitsit',
    [CuisineTypes.Cakes]: 'Kakut',

    [CuisineTypes.CoffeeCafe]: 'Kahvi/Kahvila',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Mehut/Smoothiet',
    [CuisineTypes.Milkshakes]: 'Pirtelöt',
    [CuisineTypes.BarPub]: 'Baari/Pubi',
    [CuisineTypes.WineBar]: 'Viinibaari',
    [CuisineTypes.Cocktails]: 'Cocktailit',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Pienet annokset',
    [CuisineTypes.Noodles]: 'Nuudelit',
    [CuisineTypes.Soup]: 'Keitto',
    [CuisineTypes.Schnitzel]: 'Schnitzel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Lohturuoka',
    [CuisineTypes.StreetFood]: 'Katuruoka',
    [CuisineTypes.OrganicBio]: 'Luomu',
    [CuisineTypes.KidsMenu]: 'Lasten menu',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Suositut/Yleiset',
    [CuisineCategories.AsianPacific]: 'Aasialainen/Tyynenmeren',
    [CuisineCategories.SouthAsian]: 'Etelä-Aasialainen',
    [CuisineCategories.MiddleEastMediterranean]: 'Lähi-itä/Välimeri',
    [CuisineCategories.Europe]: 'Eurooppa',
    [CuisineCategories.Americas]: 'Amerikka',
    [CuisineCategories.SeafoodSpecialty]: 'Merenelävät',
    [CuisineCategories.BreakfastBakerySweets]: 'Aamiainen, leivonnaiset/makeiset',
    [CuisineCategories.BeverageLed]: 'Juomapainotteinen',
    [CuisineCategories.OtherConcepts]: 'Muut konseptit',
  },
};
